import AWS from 'aws-sdk';

export class S3Controller {
  static digitalOceanSpaces: string = "https://dbappstorage.ams3.digitaloceanspaces.com";
  static bucketName: string = "dbappstorage";
  static spacesEndpoint: AWS.Endpoint = new AWS.Endpoint('ams3.digitaloceanspaces.com');
  static s3: AWS.S3 = new AWS.S3({
    endpoint: S3Controller.spacesEndpoint,
    accessKeyId: "DO00YK7MLCVRMNVXQRRR",
    secretAccessKey: "NG6QCViUU8buUB92f/pF8Sdiq7MGplqoyO25K++74Ws"
  });
  static mainFolder: string = "";

  public static async upload(folder: string, file: File, fileName: string): Promise<string> {
    const fileNameFinal: string =  folder + "/" + fileName;
    const params: AWS.S3.PutObjectRequest = {
      Body: file,
      Bucket: this.bucketName,
      Key: fileNameFinal,
    };

    return new Promise<string>((resolve, reject) => {
      S3Controller.s3.putObject(params)
        .on('build', (request: AWS.Request<any, any>) => {
          request.httpRequest.headers.Host = `${this.digitalOceanSpaces}`;
          request.httpRequest.headers['Content-Length'] = String(file.size);
          request.httpRequest.headers['Content-Type'] = file.type;
        //  request.httpRequest.headers['x-amz-acl'] = 'public-read';
          request.httpRequest.headers['Access-Control-Allow-Origin'] = '*';
        })
        .send((err?: Error) => {
          if (err) {
            reject(err);
          } else {
            resolve(fileNameFinal);
          }
        });
    });
  }

  public static async uploadBlobToS3(blob: Blob, folder: string, fileName: string): Promise<string> {
    const params: AWS.S3.PutObjectRequest = {
      Body: blob,
      Bucket: S3Controller.bucketName,
      Key: `${this.mainFolder}/${folder}/${fileName}`,
    };

    return new Promise<string>((resolve, reject) => {
      S3Controller.s3.upload(params, (err: Error | null, data: AWS.S3.ManagedUpload.SendData) => {
        if (err) {
          reject(err);
        } else {
          resolve(`${this.mainFolder}/${folder}/${fileName}`);
        }
      });
    });
  }

  public static async deleteS3File(filePath: string): Promise<void> {
    try {
      await S3Controller.s3.deleteObject({
        Bucket: S3Controller.bucketName,
        Key: filePath,
      }).promise();
      console.log(`File ${filePath} eliminato con successo dal bucket ${S3Controller.bucketName}.`);
    } catch (error: any) {
      console.error(`Errore durante l'eliminazione del file ${filePath} dal bucket ${S3Controller.bucketName}:`, error);
      throw error;
    }
  }

  public static async downloadS3File(filePath: string): Promise<Blob> {
    const params: AWS.S3.GetObjectRequest = {
      Bucket: this.bucketName,
      Key: filePath,
    };

    return new Promise<Blob>((resolve, reject) => {
      this.s3.getObject(params, (err: AWS.AWSError, data: AWS.S3.GetObjectOutput) => {
        if (err) {
          console.error(`Errore durante il download del file ${filePath} dal bucket ${this.bucketName}:`, err);
          reject(err);
        } else if (data.Body) {
          const blob = new Blob([data.Body as ArrayBuffer], { type: data.ContentType });
          resolve(blob);
        } else {
          reject(new Error("Data.Body is undefined"));
        }
      });
    });
  }

  public static async ensureS3Folder(path: string): Promise<void> {
    const bucket: string = S3Controller.bucketName;
    path = S3Controller.mainFolder + "/" + path;
    const parts: string[] = path.split('/').filter(part => part !== '');
    let currentPath: string = '';

    for (const part of parts) {
      currentPath += `${part}/`;
      try {
        await S3Controller.s3.headObject({ Bucket: bucket, Key: currentPath }).promise();
        console.log(`La cartella ${currentPath} esiste già.`);
      } catch (error: any) {
        if (error.code === 'NotFound') {
          await S3Controller.s3.putObject({ Bucket: bucket, Key: currentPath }).promise();
          console.log(`La cartella ${currentPath} è stata creata.`);
        } else {
          throw error;
        }
      }
    }
  }

  public static async getSignedUrl(objectPath: string): Promise<string> {
    const params: AWS.S3.GetObjectRequest & { Expires: number } = {
      Bucket: this.bucketName,
      Key: objectPath,
      Expires: 60,
    };
    return await S3Controller.s3.getSignedUrlPromise('getObject', params);
  }
  public static async fileExists(filePath: string): Promise<boolean> {
    try {
      await S3Controller.s3.headObject({
        Bucket: S3Controller.bucketName,
        Key: filePath,
      }).promise();

      return true;
    } catch (error: any) {
      if (error.code === 'NotFound' || error.statusCode === 404) {
        return false;
      }

      console.error(`Errore durante il controllo esistenza file ${filePath}:`, error);
      throw error;
    }
  }
}

